import { render, staticRenderFns } from "./borderBlock.vue?vue&type=template&id=30bf5933&scoped=true&"
import script from "./borderBlock.vue?vue&type=script&lang=js&"
export * from "./borderBlock.vue?vue&type=script&lang=js&"
import style0 from "./borderBlock.vue?vue&type=style&index=0&id=30bf5933&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bf5933",
  null
  
)

export default component.exports